export function isEmptyObj(obj) {
    if(JSON.stringify(obj) !== '{}') {
      return false
    }
    return true
  }    